module.exports = __webpack_public_path__ + "media/images/client-14-a0fcee45529d0eebc9fcfce99ca078b9.png";